import React, { useState } from 'react';

import { deletarCondo } from '../../../API/condos/Condos';
import Dialog from '../../../components/ui/Dialog/Dialog';

export default function DeleteCondominioDialog({
  open,
  condominio,
  onClose,
  onDeleted,
}) {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  if (!open || !condominio) return null;

  const handleDelete = async () => {
    setLoading(true);
    setErr('');

    try {
      const res = await deletarCondo(condominio.id);
      if (!res?.ok) {
        throw new Error(res?.error || `request_failed_${res?.status ?? ''}`);
      }

      if (onDeleted) onDeleted();
      onClose();
    } catch (e) {
      console.error('Falha ao excluir condomínio', e);
      setErr('Não foi possível excluir o condomínio.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <div className="condo-delete-dialog">
        <h2>Excluir condomínio</h2>
        <p>
          Tem certeza que deseja excluir o condomínio{' '}
          <strong>{condominio.name}</strong>?
        </p>

        {err && <div className="condo-delete-error">{err}</div>}

        <div className="condo-delete-actions">
          <button
            type="button"
            className="condo-btn secondary"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="condo-btn danger"
            onClick={handleDelete}
            disabled={loading}
          >
            {loading ? 'Excluindo...' : 'Excluir'}
          </button>
        </div>
      </div>
    </Dialog>
  );
}